import { isDevelopmentMode } from '@/shared/helpers/environmentHelper';
// TODO: remove when the document flow sections are ready for testers. Until then they exist only in local development.
export const documentFlowEnabled = isDevelopmentMode();
